var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sys-notify"},[(_vm.notifyList.length > 0)?_c('notifyDetails',{key:_vm.updateKey,ref:"notifyDetails",attrs:{"notify-list":_vm.notifyList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }